import { useEffect, useState } from 'react';
import { ChartBar, Scales } from '@phosphor-icons/react';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { AllActive } from './Tabs/AllActive';
import { CarouselDashInfos } from './components/Carousel';
import { CompositionGraphicWallet } from './components/CompositionGraphicWallet';
import { Brokerages } from './components/Brokerages/intex';
import { ActionActives } from './Tabs/ActionAcitves';
import { FiiActives } from './Tabs/FiiActives';
import { ActivesProviderWallet } from './Context/ActivesContext';
import { ManualImport } from './Tabs/ManualImport';
import { EmergenceReserve } from './Tabs/EmergenceReserve';
import { Strategy } from './Tabs/Strategy';
import { StrategyContextProvider } from './Context/StrategyContext';
import { AdjustStrategy } from './Tabs/Strategy/AdjustStrategy';
import { Simulation } from './Tabs/Simulation';
import { SimulationProvider } from './Context/SimulationContext';
import { FormSimulation } from './Tabs/Simulation/components/FormSimulation';
import { useLocation } from 'react-router-dom';

import {
  ButtonTab,
  ButtonTabContentMobile,
  Content,
  Content2,
  ContentButtonValues,
  ContentTab,
  ContentTabMobile,
  ContentTabNavigateMobile,
  SelectedTabNavigateMobile,
  TabValuesContent,
  ValuesContent,
  WalletContainer,
} from './styles';
import { useSimulation } from './hooks/SimulationHooks';
import { LinkB3AllPagesCarteira } from '../Business/components/LinkB3AllPages/integrarCarteira';
import { StocksActives } from './Tabs/StocksActives';
import { EtfActives } from './Tabs/EtfActives';
import { ReitsActives } from './Tabs/ReitsActives';
import { CryptoActives } from './Tabs/CryptoActives';

export function Wallet() {
  // @ts-ignore
  const { setTitle } = useTitleAndUser();
  const { setType } = useSimulation();
  const [tab, setTab] = useState(1);
  const [screens, setScreens] = useState<'wallet' | 'strategy' | 'simulators'>(
    'wallet'
  );
  const location = useLocation();

  useEffect(() => {
    setTitle('Carteira');
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');

    if (tabParam) {
      const parsedTab = Number(tabParam);

      if (!isNaN(parsedTab)) {
        setTab(parsedTab);
        setScreens('wallet');

        // importante para não quebrar o simulador
        if (parsedTab === 1) setType('all');
        if (parsedTab === 2) setType('action');
        if (parsedTab === 3) setType('fii');
        if (parsedTab === 5) setType('stocks');
        if (parsedTab === 6) setType('reit');
        if (parsedTab === 7) setType('etf');
        if (parsedTab === 8) setType('crypto');
      }
    }
  }, [location.search]);

  return (
    <ActivesProviderWallet>
      <StrategyContextProvider>
        <SimulationProvider>
          <WalletContainer>
            <div style={{width:'auto', }}>
              <LinkB3AllPagesCarteira/>
            </div>
            {window.screen.width > 768 && (
              <ContentTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(1);
                    setType('all');
                  }}
                  isActive={tab === 1}
                >
                  Todos os ativos
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(2);
                    setType('action');
                  }}
                  isActive={tab === 2}
                >
                  Ações
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(3);
                    setType('fii');
                  }}
                  isActive={tab === 3}
                >
                  FIIs
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(4);
                  }}
                  isActive={tab === 4}
                >
                  Renda Fixa
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(5);
                  }}
                  isActive={tab === 5}
                >
                  Stocks
                </ButtonTab>

                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(6);
                  }}
                  isActive={tab === 6}
                >
                  REITs
                </ButtonTab>

                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(7);
                  }}
                  isActive={tab === 7}
                >
                  ETFs
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(8);
                  }}
                  isActive={tab === 8}
                >
                  Criptomoedas
                </ButtonTab>
                <ButtonTab
                  onClick={() => {
                    setScreens('wallet');
                    setTab(9);
                  }}
                  isActive={tab === 9}
                >
                  Importação manual
                </ButtonTab>
              </ContentTab>
            )}
            <Content>
              {window.screen.width <= 768 && (
                <>
                  {screens !== 'simulators' && (
                    <div className="contentCarousel">
                      <CarouselDashInfos />
                    </div>
                  )}
                  <ContentTabMobile>
                    <ButtonTabContentMobile
                      onClick={() => {
                        if (screens === 'simulators') {
                          setScreens('wallet');
                        } else {
                          setScreens('simulators');
                        }
                      }}
                      active={screens === 'simulators'}
                    >
                      <Scales /> Simulador
                    </ButtonTabContentMobile>
                    <ButtonTabContentMobile
                      onClick={() => {
                        if (screens === 'strategy') {
                          setScreens('wallet');
                        } else {
                          setScreens('strategy');
                        }
                      }}
                      active={screens === 'strategy'}
                    >
                      <ChartBar />
                      Estratégia
                    </ButtonTabContentMobile>
                  </ContentTabMobile>
                  <ContentTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(1);
                      }}
                      isActive={tab === 1}
                    >
                      Todos os ativos
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(2);
                      }}
                      isActive={tab === 2}
                    >
                      Ações
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(3);
                      }}
                      isActive={tab === 3}
                    >
                      FIIs
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(4);
                      }}
                      isActive={tab === 4}
                    >
                      Renda Fixa
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(5);
                      }}
                      isActive={tab === 5}
                    >
                      Stocks
                    </SelectedTabNavigateMobile>

                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(6);
                      }}
                      isActive={tab === 6}
                    >
                      REITs
                    </SelectedTabNavigateMobile>

                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(7);
                      }}
                      isActive={tab === 7}
                    >
                      ETFs
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(8);
                      }}
                      isActive={tab === 8}
                    >
                      Criptomoedas
                    </SelectedTabNavigateMobile>
                    <SelectedTabNavigateMobile
                      onClick={() => {
                        setScreens('wallet');
                        setTab(9);
                      }}
                      isActive={tab === 9}
                    >
                      Importação manual
                    </SelectedTabNavigateMobile>
                  </ContentTabNavigateMobile>
                </>
              )}
              {window.screen.width <= 768 && (
                <>
                  <Brokerages />
                  <br />
                  {screens === 'strategy' && <AdjustStrategy />}
                  {screens === 'simulators' && <FormSimulation />}
                </>
              )}
              {tab !== 4 && (
                <ValuesContent>
                  {window.screen.width > 768 && tab !== 4 && (
                    <TabValuesContent>
                      <ContentButtonValues
                        onClick={() => {
                          if (screens === 'simulators') {
                            setScreens('wallet');
                          } else {
                            setScreens('simulators');
                          }
                        }}
                        active={screens === 'simulators'}
                      >
                        <Scales /> Simulador
                      </ContentButtonValues>
                      <ContentButtonValues
                        onClick={() => {
                          if (screens === 'strategy') {
                            setScreens('wallet');
                          } else {
                            setScreens('strategy');
                          }
                        }}
                        active={screens === 'strategy'}
                      >
                        <ChartBar />
                        Estratégia
                      </ContentButtonValues>
                    </TabValuesContent>
                  )}

                  {window.screen.width > 768 && tab !== 4 &&
                    (screens === 'strategy' ? (
                      <AdjustStrategy />
                    ) : screens === 'simulators' ? (
                      <FormSimulation />
                    ) : (
                      <div className="contentCarousel">
                        <CarouselDashInfos />
                      </div>
                    ))}

                  {screens !== 'strategy' && screens !== 'simulators' && (
                    <CompositionGraphicWallet tab={tab} />
                  )}
                </ValuesContent>
              )}

              <div style={{ background: '#efefef', borderRadius: 16 }}></div>
              {tab !== 4 && screens === 'strategy' && <Strategy />}
              {tab !== 4 && screens === 'simulators' && (
                <Simulation
                  inicialTypeAporte={
                    tab === 1
                      ? 'all'
                      : tab === 2
                      ? 'action'
                      : tab === 3
                      ? 'fii'
                      : tab === 5
                      ? 'stocks'
                      : tab === 6
                      ? 'reit'
                      : tab === 7
                      ? 'etf'
                      : tab === 8
                      ? 'crypto'
                      : 'all'
                  }
                />
              )}
              {screens === 'wallet' && tab === 1 && <AllActive />}
              {screens === 'wallet' && tab === 2 && <ActionActives />}
              {screens === 'wallet' && tab === 3 && <FiiActives />}
              {/* 
                aqui era a tab 4, mas foi transferido para baixo 
                pois tinha bug no Content para a page nova da renda fixa.  
              */}
              {screens === 'wallet' && tab === 5 && <StocksActives />}
              {screens === 'wallet' && tab === 6 && <ReitsActives />}
              {screens === 'wallet' && tab === 7 && <EtfActives />}
              {screens === 'wallet' && tab === 8 && <CryptoActives />}
              {screens === 'wallet' && tab === 9 && <ManualImport />}
            </Content>
            {/* aqui é a renda fixa */}
            <Content2>
              {screens === 'wallet' && tab === 4 && <EmergenceReserve setTab={setTab} setScreens={setScreens} />}
            </Content2>
          </WalletContainer>
        </SimulationProvider>
      </StrategyContextProvider>
    </ActivesProviderWallet>
  );
}